import { CardHeader } from '../card';
import { styled } from '../styled';
export var ExpansionPanelHeader = styled(CardHeader, { name: 'QuantumExpansionPanelHeader' })({
    margin: 0,
});
